import { Building2, Users } from 'lucide-react';
import { cn } from '../../lib/utils';
import type { AnalyticsLens } from '../../types/accountAnalytics';

// Segmented AM / Business lens toggle. The lens changes which charts are primary
// + the table's default grouping/sort; filters + table + roster are shared.
export function LensSwitcher({
  lens,
  onChange,
}: {
  lens: AnalyticsLens;
  onChange: (lens: AnalyticsLens) => void;
}) {
  const btn = (value: AnalyticsLens, label: string, Icon: typeof Users) => (
    <button
      type="button"
      onClick={() => onChange(value)}
      aria-pressed={lens === value}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium transition-colors',
        lens === value ? 'bg-kyck-600 text-white' : 'bg-white text-slate-600 hover:bg-slate-50',
      )}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );
  return (
    <div className="inline-flex overflow-hidden rounded-md border border-slate-300">
      {btn('am', 'AM lens', Users)}
      {btn('business', 'Business lens', Building2)}
    </div>
  );
}
